<!-- 简报看板 -->
<template>
  <div class="panel" style="height:100%;">
    <div class="panel-title">
      <span>简报看板</span>
      <p style="position: relative; left: 20px; display: inline; font-size: small;">
        <a-range-picker
          size="small"
          style="font-size: 13px;"
          :default-value="[moment().startOf('year'), moment().endOf('year')]"
          :ranges="{
            '本周': [moment().startOf('week'), moment().endOf('week')],
            '上周': [moment().add(-1, 'W').startOf('week'), moment().add(-1, 'W').endOf('week')],
            '本月': [moment().startOf('month'), moment().endOf('month')],
            '上月': [moment().add(-1, 'M').startOf('month'), moment().add(-1, 'M').endOf('month')],
            '本年': [moment().startOf('year'), moment().endOf('year')],
            '上年': [moment().add(-1, 'Y').startOf('year'), moment().add(-1, 'Y').endOf('year')]
          }"
          @change="onChange"
        />
      </p>
    </div>
    <a-row v-for="(item, index) in readNewspaperLister" :key="index">
      <a-col v-for="item1 in item" :span="8" class="readNewspaper" :key="item1.id">
        <div class="ico" :style="{backgroundColor: item1.color}">
          <a-tooltip placement="topLeft">
            <template slot="title">{{ item1.formula || item1.name }}</template>
            <a-icon :type="item1.icon" style="font-size: 20px;" />
          </a-tooltip>
        </div>
        <div class="value">
          <a-tooltip placement="topLeft">
            <template
              slot="title"
            >{{ item1.num ? parseFloat(item1.num).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : item1.nums}}</template>
            <span>{{ item1.value }}</span>
          </a-tooltip>
          <span v-html="item1.name" />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment'
import db from '@/utils/localstorage'
import { FormatTime } from '@/utils/timer'
import { mapState } from 'vuex'
export default {
  props: {
    readNewspaperList: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.account.permissions
    })
  },
  beforeMount () {
    // 默认查询当前年
    let timeArr = [moment().startOf('year'), moment().endOf('year')]
    let time = {}
    time.startDate = FormatTime(timeArr[0], 'YYYY-MM-DD')
    time.endDate = FormatTime(timeArr[1], 'YYYY-MM-DD')
    const permissions = this.permissions
    // 管理员看板  1管理员 23总经理
    if (permissions.includes('adminHome')) {
      this.readNewspaperLister = this.adminDataList
      this.timefentch(time)
    } else if (permissions.includes('marketHome')) { // 销售看板
      this.readNewspaperLister = this.sellDataList
      this.getSellData(time)
    } else {
      this.readNewspaperLister = this.readNewspaperList
      if (this.readNewspaperLister.length === 0) {
        this.count = 1
        this.readNewspaperLister = this.readNewspaperListed
        this.timefentch(time)
      } else {
        this.count = 0
      }
    }
  },
  data () {
    return {
      dbUserRoleIdList: db.get('USER').roleId.split(','),
      count: 0,
      readNewspaperLister: [], // 值
      readNewspaperListed: [
        [
          {
            id: 1,
            value: 0,
            num: 0, // 金额千分位
            nums: 0, // 个数
            name: '当前客户数(个)',
            color: '#15BC83',
            icon: 'user'
          },
          {
            id: 2,
            value: 0,
            num: 0,
            nums: 0, // 个数
            name: '新增客户数(个)',
            color: '#15BC83',
            icon: 'inbox'
          },
          {
            id: 3,
            value: 0,
            num: 0,
            name: '回款计划总额',
            color: '#0089fe',
            icon: 'clock-circle'
          }
        ],
        [
          {
            id: 4,
            value: 0,
            num: 0,
            name: '新增回款总额',
            color: '#0089fe',
            icon: 'dollar'
          },
          {
            id: 5,
            value: 0,
            num: 0,
            name: '合同订单总额',
            color: '#5CDBD3',
            icon: 'euro'
          },
          {
            id: 6,
            value: 0,
            num: 0,
            nums: 0, // 个数
            name: '合同订单(个)',
            color: '#5CDBD3',
            icon: 'trademark'
          }
        ],
        [
          {
            id: 7,
            value: 0,
            num: 0,
            name: '采购单合同总额',
            color: '#FE9400',
            icon: 'pay-circle'
          },
          {
            id: 8,
            value: 0,
            num: 0,
            name: '采购单付款总额',
            color: '#FE9400',
            icon: 'pound'
          }
        ]
      ],
      sellDataList: [// 销售看板内容
        [
          {
            id: 1,
            value: 0,
            num: 0,
            nums: 0, // 个数
            name: '合同数量(个)',
            color: '#0089fe',
            icon: 'profile'
          },
          {
            id: 2,
            value: 0,
            num: 0,
            name: '合同总额',
            color: '#0089fe',
            icon: 'pay-circle'
          },
          {
            id: 5,
            value: 0,
            num: 0,
            name: '已回款总额',
            color: '#5CDBD3',
            icon: 'check-circle'
          }
        ],
        [
          {
            id: 6,
            value: 0,
            num: 0,
            name: '未回款总额',
            color: '#FE9400',
            icon: 'exclamation-circle'
          },
          {
            id: 7,
            value: 0,
            num: 0,
            name: '应收款',
            color: '#5CDBD3',
            icon: 'pay-circle'
          },
          {
            id: 8,
            value: 0,
            num: 0,
            name: '逾期款',
            color: 'red',
            icon: 'warning'
          }
        ],
        [
          {
            id: 3,
            value: 0,
            num: 0,
            name: '个人成本',
            color: '#42b983',
            icon: 'user'
          },
          {
            id: 4,
            value: 0,
            num: 0,
            name: '项目成本',
            color: '#42b983',
            icon: 'trademark'
          },
          {
            id: 9,
            value: 0,
            num: 0,
            name: '销售机会成本',
            color: '#42b983',
            icon: 'bar-chart'
          }
        ]
      ],
      adminDataList: [ // 管理员看板内容
        [
          {
            id: 1,
            value: 0,
            num: 0,
            name: '项目盈亏',
            color: '#5CDBD3',
            formula: `计算方式： 已回款- 项目成本（采购 + ${this.$tree([], 'offices/courtesyApplication/index') ? this.$tree([], 'offices/courtesyApplication/index') + ' +' : ''}  开票税金）- 人员成本 - 资金占用成本 - 费用报销 + 收票税金 - 销售机会成本`,
            icon: 'money-collect'
          },
          {
            id: 2,
            value: 0,
            num: 0,
            name: '合同订单总额',
            color: '#0089fe',
            icon: 'euro'
          },
          {
            id: 3,
            value: 0,
            num: 0,
            name: '已回款总额',
            color: '#52c41a',
            icon: 'pay-circle'
          }
        ],
        [
          {
            id: 4,
            value: 0,
            num: 0,
            name: '未回款总额',
            color: '#FE9400',
            formula: '计算方式： 由回款计划数据计算',
            icon: 'info-circle'
          },
          {
            id: 5,
            value: 0,
            num: 0,
            name: '项目资金占用成本',
            color: '#5CDBD3',
            icon: 'align-center'
          },
          {
            id: 6,
            value: 0,
            num: 0,
            name: '人员成本',
            color: '#0089fe',
            icon: 'team'
          }
        ],
        [
          {
            id: 7,
            value: 0,
            num: 0,
            name: '项目成本',
            color: '#42b983',
            formula: '计算方式： 采购 + 现金支付 + 开票税金',
            icon: 'project'
          },
          {
            id: 8,
            value: 0,
            num: 0,
            name: '个人成本',
            color: '#42b983',
            icon: 'user'
          },
          {
            id: 9,
            value: 0,
            num: 0,
            name: '销售机会成本',
            color: '#42b983',
            icon: 'bar-chart'
          }
        ]
      ]
    }
  },
  methods: {
    moment,
    timeChange1 (t1, t2) {
      let time = {}
      time.startDate = t2[0].toString()
      time.endDate = t2[1].toString()
      const permissions = this.permissions
      if (permissions.includes('adminHome')) {
        this.timefentch(time)
      } else if (permissions.includes('marketHome')) { // 销售看板
        this.getSellData(time)
      } else {
        // if (this.count === 0) {
        //   this.$emit('timeChanged', time)
        // } else {
        this.timefentch(time)
        // }
      }
    },
    onChange (t1, t2) {
      this.timeChange1(t1, t2)
    },
    timefentch (time) {
      this.$get('/home/countBoardWeb', { ...time }).then(res => {
        const permissions = this.permissions
        if (permissions.includes('adminHome')) { // 判断当前用户是否为 管理员 看板
          // console.log(11111111111111111111, res.data.data.saleMoney)
          // 项目盈亏 = 已回款总额-项目成本-个人成本
          this.readNewspaperLister[0][0].value = this.bigNumberTransform(Number(res.data.data.profitAmount))
          this.readNewspaperLister[0][1].value = this.bigNumberTransform(res.data.data.contractMoney) // 合同总额
          this.readNewspaperLister[0][2].value = this.bigNumberTransform(res.data.data.backMoney) // 已回款
          this.readNewspaperLister[0][0].num = Number(res.data.data.profitAmount)
          this.readNewspaperLister[0][1].num = res.data.data.contractMoney// 合同总额
          this.readNewspaperLister[0][2].num = res.data.data.backMoney // 已回款
          // 第二行
          // 逾期款
          this.readNewspaperLister[1][0].value = this.bigNumberTransform(res.data.data.unBackMoney) // 未回款/逾期款
          this.readNewspaperLister[1][0].num = res.data.data.unBackMoney // 未回款/逾期款
          let yq = this.bigNumberTransform(res.data.data.overMoney)
          this.readNewspaperLister[1][0].name = `未回款<div style="color:red;"><b>(逾期款:${yq})</b></div>`
          this.readNewspaperLister[1][1].value = this.bigNumberTransform(res.data.data.fundCost) // 项目资金管理
          this.readNewspaperLister[1][2].value = this.bigNumberTransform(res.data.data.humanCost) // 人员成本管理
          this.readNewspaperLister[1][1].num = res.data.data.fundCost // 项目资金管理
          this.readNewspaperLister[1][2].num = res.data.data.humanCost // 人员成本管理
          // 第三行
          this.readNewspaperLister[2][0].value = this.bigNumberTransform(res.data.data.projectCost) // 项目成本
          this.readNewspaperLister[2][1].value = this.bigNumberTransform(res.data.data.personalCost) // 个人成本
          this.readNewspaperLister[2][2].value = this.bigNumberTransform(res.data.data.saleMoney)// 销售机会
          this.readNewspaperLister[2][0].num = res.data.data.projectCost // 项目成本
          this.readNewspaperLister[2][1].num = res.data.data.personalCost // 个人成本
          this.readNewspaperLister[2][2].num = res.data.data.saleMoney// 销售机会
        } else {
          // console.log(2222222222222222222)
          this.readNewspaperLister[0][0].value = this.readNewspaperLister[0][0].nums = res.data.data.countCustomer // 当前客户
          this.readNewspaperLister[0][1].value = this.readNewspaperLister[0][1].nums = res.data.data.countCustomerAdd // 新增客户数
          this.readNewspaperLister[0][2].value = this.bigNumberTransform(res.data.data.backPlanMoney) // 回款计划总额
          this.readNewspaperLister[1][0].value = this.bigNumberTransform(res.data.data.backMoney) // 新增回款总额
          this.readNewspaperLister[1][1].value = this.bigNumberTransform(res.data.data.contractMoney) //  合同订单总额
          this.readNewspaperLister[0][2].num = res.data.data.backPlanMoney // 回款计划总额
          this.readNewspaperLister[1][0].num = res.data.data.backMoney // 新增回款总额
          this.readNewspaperLister[1][1].num = res.data.data.contractMoney //  合同订单总额
          this.readNewspaperLister[1][2].value = this.readNewspaperLister[1][2].nums = res.data.data.contractCount // 合同总数
          this.readNewspaperLister[2][0].value = this.bigNumberTransform(res.data.data.purchaseMoney) // 采购单合同总额
          this.readNewspaperLister[2][1].value = this.bigNumberTransform(res.data.data.payRecordMoney) // 采购单付款总饿 = 付款记录总额
          this.readNewspaperLister[2][0].num = res.data.data.purchaseMoney // 采购单合同总额
          this.readNewspaperLister[2][1].num = res.data.data.payRecordMoney // 采购单付款总饿 = 付款记录总额
        }
      })
    },
    getSellData (time) {
      this.$get('/home/countBoardForSell', { ...time }).then(res => {
        this.readNewspaperLister[0][0].value = this.readNewspaperLister[0][0].nums = res.data.data.contractCount // 合同数量
        this.readNewspaperLister[0][1].value = this.bigNumberTransform(res.data.data.contractMoney) // 合同总额
        this.readNewspaperLister[0][2].value = this.bigNumberTransform(res.data.data.backMoney) // 已回款总饿
        this.readNewspaperLister[1][0].value = this.bigNumberTransform(res.data.data.unBackMoney) // 未回款总饿
        this.readNewspaperLister[1][1].value = this.bigNumberTransform(res.data.data.oughtMoney) // 应收款
        this.readNewspaperLister[1][2].value = this.bigNumberTransform(res.data.data.overMoney) // 逾期款
        this.readNewspaperLister[2][0].value = this.bigNumberTransform(res.data.data.personalCost) // 个人成本
        this.readNewspaperLister[2][1].value = this.bigNumberTransform(res.data.data.projectCost) // 项目成本
        this.readNewspaperLister[2][2].value = this.bigNumberTransform(res.data.data.saleMoney)// 销售机会
        // console.log(res.data.data.saleMoney, 'res.data.data.saleMoney')
        this.readNewspaperLister[0][1].num = res.data.data.contractMoney // 合同总额
        this.readNewspaperLister[0][2].num = res.data.data.backMoney // 已回款总饿
        this.readNewspaperLister[1][0].num = res.data.data.unBackMoney // 未回款总饿
        this.readNewspaperLister[1][1].num = res.data.data.oughtMoney // 应收款
        this.readNewspaperLister[1][2].num = res.data.data.overMoney // 逾期款
        this.readNewspaperLister[2][0].num = res.data.data.personalCost // 个人成本
        this.readNewspaperLister[2][1].num = res.data.data.projectCost // 项目成本
        this.readNewspaperLister[2][2].num = res.data.data.saleMoney// 销售机会
      })
    },
    bigNumberTransform (value) {
      if (value) {
        let param = ''
        let k = 10000
        if (value < k) {
          if (value < -10000) {
            if (value < -100000000) {
              let yiyuan = (value / 100000000).toFixed(2)
              return yiyuan + '亿'
            } else {
              let fsy = (value / 10000).toFixed(2)
              return fsy + '万'
            }
          } else {
            param = value.toFixed(2)
            return param + '元'
          }
        } else {
          let sizes = ['', '万', '亿', '万亿']
          let i
          i = Math.floor(Math.log(value) / Math.log(k))
          param = `${((value / Math.pow(k, i))).toFixed(2)}${sizes[i]}`
          return param
        }
      } else {
        return value || 0 + '元'
      }
    }
    // home页面接收值
    // timeChanged (time) {
    //   this.timefentch(time)
    // },
  }
}
</script>

<style lang="less" scoped>
.panel {
  padding-bottom: 0.6rem;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 10px;

  .panel-title {
    width: 100%;
    border-bottom: solid 1px #e9e9e9;
    line-height: 50px;
    padding-left: 15px;
    position: relative;

    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 30px;
      background-color: #0079fe;
      position: absolute;
      left: 0;
      top: 10px;
      border-radius: 4px;
    }

    span {
      &:first-child {
        font-size: 18px !important;
        font-weight: 400;
      }
    }
  }

  .readNewspaper {
    display: flex;
    position: relative;
    // margin: 30px 0px 30px 0px;
    margin: 3% 0;
    padding-left: 30px;
    padding-right: 0px;

    .ico {
      display: inline-block;
      background-color: #0089fe;
      border-radius: 38%;
      width: 50px;
      height: 50px;
      line-height: 50px;
      color: #ffffff;
      text-align: center;
      font-size: 20px;
      // position: relative;
      // top: 6px;
      /deep/ svg {
        font-size: 20px !important;
      }
    }

    .value {
      margin-left: 0.6rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      span {
        font-size: 14px;
        color: #797979;

        &:first-child {
          font-size: 22px !important;
          color: #333333;
        }
      }
    }
  }

  .noticeList {
    padding: 16px 15px;

    .notice {
      display: flex;
      cursor: pointer;
      justify-content: space-between;

      .notice-title {
        font-size: 14px;
        color: #333333;
        margin-bottom: 5px;
      }

      .notice-content {
        font-size: 12px;
        color: #797979;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/briefingBoard.vue